import React, { useState } from 'react';
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

export default function ShowError(props) {
    const [errorMessage] = useState(props.errorMessage)
    const [redirectTo] = useState(props.redirectTo)
    const [errorStatusCode] = useState(props.errorStatusCode ? props.errorStatusCode : "400")

    return (
        <React.Fragment>
                <div className="my-5 pt-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center my-5">
                                    <h1 className="fw-bold text-error">{errorStatusCode[0]}<span className="error-text"> {errorStatusCode[1]}</span> {errorStatusCode[2]}</h1>
                                    <h3 className="text-uppercase">{errorMessage}</h3>
                                    <div className="mt-5 text-center">
                                        <Link to={redirectTo} className="btn btn-primary waves-effect waves-light" >Go Back</Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
    )
}